<template>
  <div id="main" ref="topBanner">
    <top-header :type="1" />
    <div class="banner_con">
      <van-swipe
        v-if="banners.length"
        class="swiper"
        :autoplay="3000"
        indicator-color="white"
      >
        <van-swipe-item v-for="(item, index) in banners" :key="index">
          <img
            :src="imgPath + 'sImgGg/' + item.imgid + '.' + item.suffix"
            alt=""
            v-if="'null' !== item.itemId && item.itemId"
            @click="toProject(item.itemId, item.old)"
          />
          <a v-else :href="item.lj">
            <img
              :src="imgPath + 'sImgGg/' + item.imgid + '.' + item.suffix"
              alt=""
            />
          </a>
        </van-swipe-item>
      </van-swipe>
      <!-- <swiper class="swiper" v-if="banners.length" ref="swiper" :options="swiperOption">
        <swiper-slide v-for="(item, index) in banners" :key="index">
            <img :src="imgPath + 'sImgGg/' + item.imgid + '.' + item.suffix" alt=""  v-if="'null'!==item.itemId&&item.itemId"
                 @click="toProject(item.itemId,item.old)" >
          <a v-else  :href="item.lj" >
            <img  :src="imgPath + 'sImgGg/' + item.imgid + '.' + item.suffix" alt="">
          </a>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper> -->
    </div>
    <div class="five_con m_flex_box flex_jz">
      <div class="inner" @click="toUrl('/projetList', {})">
        <img src="@/assets/img/index/1.png" alt="" />
        <p>新房</p>
      </div>
      <div class="inner" @click="toUrl('/houseList', {})">
        <img src="@/assets/img/index/2.png" alt="" />
        <p>二手房</p>
      </div>
      <div class="inner" @click="toUrl('/publicAnnouncement', {})">
        <img src="@/assets/img/index/3.png" alt="" />
        <p>公告公示</p>
      </div>
      <div class="inner" @click="toUrl('/server', {})">
        <img src="@/assets/img/index/4.png" alt="" />
        <p>便民功能</p>
      </div>
      <div class="inner" @click="toUrl('/fixtures_home', {})">
        <img src="@/assets/img/index/6.png" alt="" />
        <p>装修</p>
      </div>
    </div>
    <van-swipe>
      <van-swipe-item>
        <div class="ten_con m_flex_box flex_vw flex_jz">
          <div class="inner" @click="toUrl('/findProjectName', {})">
            <img src="@/assets/img/index/11.png" alt="" />
            <p>项目找房</p>
          </div>
          <div class="inner" @click="toUrl('/oneHouse', {})">
            <img src="@/assets/img/index/12.png" alt="" />
            <p>一房一价</p>
          </div>
          <router-link to="/announcePre" class="inner">
            <img src="@/assets/img/index/13.png" alt="" />
            <p>预售公示</p>
          </router-link>
          <div class="inner" @click="toUrl('/newsMain', { type: 3 })">
            <img src="@/assets/img/index/14.png" alt="" />
            <p>楼市动态</p>
          </div>
          <div class="inner" @click="toUrl('/sellHouse', {})">
            <img src="@/assets/img/index/15.png" alt="" />
            <p>业主直卖</p>
          </div>
          <div class="inner" @click="toUrl('/secondHouseList', {})">
            <img src="@/assets/img/index/16.png" alt="" />
            <p>二手房源</p>
          </div>
          <div class="inner" @click="toUrl('/findProject', {})">
            <img src="@/assets/img/index/17.png" alt="" />
            <p>二手小区</p>
          </div>
          <div class="inner" @click="toUrl('/checkHouse', {})">
            <img src="@/assets/img/index/18.png" alt="" />
            <p>房源核验</p>
          </div>
          <div class="inner" @click="toUrl('/newsMain', {})">
            <img src="@/assets/img/index/220.png" alt="" />
            <p>楼盘资讯</p>
          </div>
          <div class="inner" @click="toUrl('/lawyer', {})">
            <img src="@/assets/img/index/222.png" alt="" />
            <p>法律咨询</p>
          </div>
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div class="ten_con m_flex_box flex_vw flex_jz">
          <div class="inner" @click="toUrl('/newMap', {})">
            <img src="@/assets/img/index/111.png" alt="" />
            <p>地图找房</p>
          </div>
          <div class="inner" @click="toUrl('/AnnounceMechanism', {})">
            <img src="@/assets/img/index/112.png" alt="" />
            <p>机构公示</p>
          </div>
          <div class="inner" @click="toUrl('/personListMain', { compType: 0 })">
            <img src="@/assets/img/index/113.png" alt="" />
            <p>找经纪人</p>
          </div>
          <div class="inner" @click="toUrl('/redBlackRank', {})">
            <img src="@/assets/img/index/114.png" alt="" />
            <p>明星榜单</p>
          </div>

          <div class="inner" @click="toUrl('/preProgress', {})">
            <img src="@/assets/img/index/115.png" alt="" />
            <p>预售进度</p>
          </div>
          <div class="inner" @click="toUrl('/complainAndSuggest', {})">
            <img src="@/assets/img/index/116.png" alt="" />
            <p>投诉评价</p>
          </div>
          <div class="inner" @click="toUrl('/buyHouse', {})">
            <img src="@/assets/img/index/117.png" alt="" />
            <p>我要买房</p>
          </div>
          <div class="inner" @click="toUrl('/downLoad', {})">
            <img src="@/assets/img/index/118.png" alt="" />
            <p>下载中心</p>
          </div>
          <div class="inner" @click="toUrl('/distory', {})">
            <img src="@/assets/img/new/15.png" alt="" />
            <p>注销公示</p>
          </div>
          <!-- <div class="inner" @click="toUrl('/newsMain', {type:2})">
            <img src="@/assets/img/index/120.png" alt="">
            <p>本地楼市</p>
          </div> -->
          <div class="inner">
            <a href="https://work.weixin.qq.com/kfid/kfcc7e91a12e3b4f650">
              <img src="@/assets/img/121.png" alt="" />
              <p>在线客服</p>
            </a>
          </div>
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div class="ten_con m_flex_box flex_vw flex_jz">
          <!-- <div class="inner"  @click="toUrl('/enterpriseAccess', {})" >
            <img src="@/assets/img/index/111.png" alt="">
            <p>开发入网</p>
          </div> -->
          <div class="inner" @click="toUrl('/myOrder', {})">
            <img src="@/assets/img/index/19.png" alt="" />
            <p>预约过户</p>
          </div>
          <div class="inner" @click="toUrl('/procedure', {})">
            <img src="@/assets/img/index/110.png" alt="" />
            <p>买卖流程</p>
          </div>
          <div class="inner" @click="toUrl('/lotteryProject', {})">
            <img src="@/assets/img/new/16.png" alt="" />
            <p>报名选房</p>
          </div>
          <div class="inner"></div>
          <div class="inner"></div>
        </div>
      </van-swipe-item>
    </van-swipe>
    <div class="index_aside m_flex_box flex_jz">
      <div
        class="left new_left m_flex_box flex_vc"
        @click="
          jumpPage(
            'https://www.xzhouse.com.cn/page/generation/xzxxw_new/#/seeHouse'
          )
        "
      >
        <div>
          <h4>我要买新房</h4>
          <p>国企平台带看新房</p>
        </div>
      </div>
      <div
        class="right new_right m_flex_box flex_vc"
        @click="
          jumpPage(
            'https://www.xzhouse.com.cn/page/generation/xzxxw_new/#/proxyService'
          )
        "
      >
        <div>
          <h4>我要代办</h4>
          <p>代办服务价格透明</p>
        </div>
      </div>
    </div>
    <div class="ad_con" v-for="item in ad" :key="item.imgid">
      <img
        :src="imgPath + 'sImgGg/' + item.imgid + '.' + item.suffix"
        alt=""
        v-if="'null' !== item.itemId && item.itemId"
        @click="toProject(item.itemId, item.old)"
      />
      <a v-else :href="item.lj | formUrl">
        <img
          :src="imgPath + 'sImgGg/' + item.imgid + '.' + item.suffix"
          alt=""
        />
      </a>
    </div>
    <div class="index_aside m_flex_box flex_jz">
      <div
        class="left m_flex_box flex_vc"
        @click="
          jumpPage(
            'https://www.xzhouse.com.cn/page/generation/xzxxw_new/#/buyOldHouse'
          )
        "
      >
        <div>
          <h4>我要买二手房</h4>
          <p>国企平台定制找房</p>
        </div>
      </div>
      <!-- <div class="right m_flex_box flex_vc flex_hc" @click="toUrl('/sellers')"> -->
      <div
        class="right m_flex_box flex_vc"
        @click="
          jumpPage(
            'https://www.xzhouse.com.cn/page/generation/xzxxw_new/#/sellers'
          )
        "
      >
        <div>
          <h4>我要卖二手房</h4>
          <p>房屋估价卖房委托</p>
        </div>
      </div>
    </div>
    <div class="banner_con" style="margin-top:0.2rem">
      <van-swipe
        v-if="yXbanners.length"
        class="swiper"
        :autoplay="3000"
        indicator-color="white"
      >
        <van-swipe-item v-for="(item, index) in yXbanners" :key="index">
          <img :src="item.image" alt="" @click="toYxProject(item.itemId)" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="news_con">
      <div class="tit_con m_flex_box flex_vc flex_jz">
        <h4>楼盘资讯</h4>
        <p class="m_flex_box flex_vc" @click="getNews">
          <img src="@/assets/img/index/change.png" alt="" />
          <span>换一换</span>
        </p>
      </div>
      <div class="news_inner m_flex_box flex_vc flex_jz">
        <div class="left">
          <p>
            <span class="line_comp2">{{ newsMain.mc }}</span>
          </p>
          <img
            @click="toUrl('/newsDetail', { id: newsMain.nrid })"
            v-lazy="
              newsMain.imgid
                ? imgPath + 'sImgXw/' + newsMain.imgid + '.jpg'
                : ''
            "
          />
        </div>
        <div class="right">
          <div
            class="row m_flex_box flex_vc"
            v-for="(item, index) in newsSm"
            :key="index"
          >
            <p
              @click="toUrl('/newsDetail', { id: item.nrid })"
              class="line_comp2"
            >
              {{ item.mc }}
            </p>
            <img
              @click="toUrl('/newsDetail', { id: item.nrid })"
              v-lazy="imgPath + 'sImgXw/' + item.imgid + '.jpg'"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="pad_top{ padding-top: ; }" v-show="isFixed"></div> -->
    <van-sticky offset-top="1.1rem">
      <div class="tab_con m_flex_box flex_vb flex_hc">
        <span :class="tab === 0 ? 'active' : ''" @click="changeTab(0)"
          >预售公示</span
        >
        <span :class="tab === 1 ? 'active' : ''" @click="changeTab(1)"
          >新房</span
        >
        <span :class="tab === 2 ? 'active' : ''" @click="changeTab(2)"
          >二手房</span
        >
      </div>
    </van-sticky>
    <div class="recommond_con m_flex_box flex_jz">
      <div class="inner" v-for="(item, index) in recommondList" :key="index">
        <i>推荐</i>
        <h5 @click="toProject(item.id, item.old)" class="line_comp1">
          {{ item.tgmc }}
        </h5>
        <p class="line_comp1">{{ item.xmdz }}</p>
        <div
          class="img_con m_flex_box flex_jz"
          @click="toProject(item.id, item.old)"
        >
          <img v-lazy="imgPath + 'sImgMin/' + item.xmfm + '.jpg'" />
          <img v-lazy="imgPath + 'sImgMin/' + item.xmfm2 + '.jpg'" />
        </div>
      </div>
    </div>
    <div>
      <div style="height:80vh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="list_con new_list" v-show="tab === 1">
            <div
              class="inner m_flex_box flex_vc"
              v-for="(item, index) in list"
              :key="index"
              @click="toProject(item.id, item.old)"
            >
              <img
                class="banner"
                v-lazy="imgPath + 'sImgMin/' + item.xmfm + '.jpg'"
              />
              <div class="new_r">
                <div class="m_flex_box flex_vc flex_jz tit">
                  <h4 class="line_comp1">{{ item.tgmc }}</h4>
                  <i>{{ item.xsqkStr }}</i>
                </div>
                <p class="line_comp1 col_gray">
                  {{ item.xmdz ? item.xmdz : "暂无地址信息" }}
                </p>
                <div class="m_flex_box flex_jz flex_vc">
                  <div class="m_flex_box flex_vc info">
                    <p>
                      评分：<span>{{ item.zScore }}</span>
                    </p>
                    <p>访问量：{{ item.fwl | formatwan }}</p>
                  </div>
                  <a @click.stop="callTo(item.zxdh, 3, item.id)" class="tel"
                    ><img src="@/assets/img/tel.png" alt=""
                  /></a>
                </div>
                <div class="m_flex_box flex_jz flex_vc">
                  <div class="col_red m_flex_box flex_vb">
                    <h4>{{ item.priceStr }}</h4>
                    <span v-show="item.priceStr !== '暂无'">元/平</span>
                  </div>
                  <p v-if="item.ksts" class="m_flex_box flex_vc text">
                    <span
                      @click.stop
                      @click="toOneHouseOnePrice(item.id, item.xzqh)"
                      >一房一价</span
                    >
                    <van-icon name="play" />
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="list_con old_list" v-show="tab === 2">
            <div
              class="inner m_flex_box flex_vc"
              v-for="(item, index) in list"
              :key="index"
              @click="
                toUrl('/houseDetail', {
                  mainId: item.mainId,
                  houseListedId: item.id,
                })
              "
            >
              <div class="inner_l">
                <img
                  class="banner"
                  v-lazy="imgPath + 'sClf/' + item.fileId + '.jpg'"
                />
                <i v-if="index < 3">最新</i>
              </div>
              <div class="new_r">
                <div class="m_flex_box flex_vc flex_jz tit">
                  <h4 class="line_comp1">{{ item.tgmc }}</h4>
                  <i>在售</i>
                </div>
                <p class="line_comp1 col_gray">
                  {{ item.xzqh }} / {{ item.zmjCount }}m² / {{ item.room }}室{{
                    item.hall
                  }}厅
                </p>
                <div class="m_flex_box flex_jz">
                  <div class="price m_flex_box flex_vb">
                    <h4>{{ item.listedPrice / 10000 }}万</h4>
                    <p>{{ item.unitPrice }}元/平</p>
                  </div>
                  <a
                    @click.stop="
                      callPhone(
                        item.phoneNum == null ? '暂无' : item.phoneNum,
                        item.listedType,
                        item.listedUserId
                      )
                    "
                    class="tel"
                    ><img src="@/assets/img/tel.png" alt=""
                  /></a>
                </div>
                <div class="num m_flex_box flex_vc">
                  <img src="@/assets/img/check.png" alt="" /><span
                    >核验编码</span
                  >{{ item.uniqueCode }}
                </div>
              </div>
            </div>
          </div>
          <div class="list_con pre_list" v-show="tab === 0">
            <div
              class="inner m_flex_box"
              v-for="(item, index) in list"
              :key="index"
              @click="toAnnounce(item.SaleItemID)"
            >
              <div class="inner_l">
                <img
                  class="banner"
                  v-lazy="imgPath + 'sImgSale/' + item.SalePermitID + '.jpg'"
                />
              </div>
              <div class="new_r">
                <div class="m_flex_box flex_vc flex_jz tit">
                  <h4 class="line_comp1">{{ item.tgmc }}</h4>
                  <span v-if="index < 3">最新</span>
                </div>
                <p class="line_comp1 col_gray">{{ item.CertificateNO }}</p>
                <p class="line_comp1 col_gray">
                  [预售时间] {{ item.CertificateTime }}
                </p>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <img class="to_top" @click="toTop" src="@/assets/img/toTop.png" alt="" />
    <footer-con></footer-con>
  </div>
</template>

<script>
import qs from "qs";
import topHeader from "@/components/header";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import footerCon from "@/components/footer";
import "swiper/swiper-bundle.css";
export default {
  name: "Home",
  data() {
    return {
      imageList: [
        "https://img.yzcdn.cn/vant/apple-1.jpg",
        "https://img.yzcdn.cn/vant/apple-2.jpg",
      ],
      current: 0,
      banners: [],
      yXbanners: [],
      ad: [],
      tab: 1,
      list: [],
      loading: false,
      finished: false,
      newsPage: 1,
      newsSm: [],
      newsMain: {},
      recommondList: [],
      listPage: 1,
      isFixed: false,
      offsetTop: 0,
    };
  },
  components: {
    footerCon,
    topHeader,
    Swiper,
    SwiperSlide,
  },
  filters: {
    formUrl(param) {
      var flag = false;
      var ua = navigator.userAgent;
      var uaList = ua.split(" ");
      for (var i = 0; i < uaList.length; i++) {
        if (uaList[i].indexOf("device") > -1) {
          flag = true;
          return param;
        }
      }
      if (!flag) {
        if (param.indexOf("type=lawyerList")) {
          return "https://www.xzhouse.com.cn/page/generation/xzxxw/#/lawyer";
        } else if (param.indexOf("type=insurance")) {
          return "https://www.xzhouse.com.cn/page/generation/xzxxw/#/integral";
        } else {
          return param.split("?")[0];
        }
      }
    },
    formatwan(param) {
      if (param >= 10000) {
        return (param / 10000).toFixed(2) + "w";
      } else {
        return param;
      }
      // var str = param;
      //
      // if (param.length > 4) {
      //   //获取万位长度字符串
      //   var str1 = str.substring(0, str.length - 4);
      //   var str2 = str.substring(str1.length, 1);
      //   var str3;
      //   if (str2.length == 0) {
      //      str3 = str1 + "." + 0;
      //   } else {
      //      str3 = str1 + "." + str2;
      //   }
      //   return str3;
      // } else {
      //   var str6 = str.substring(0, 1);
      //   var str7 = "0." + str6;
      //   return str7;
      // }
    },
  },
  created() {},
  mounted() {
    this.getAd();
    this.getNews();
    this.getRecommond();
    this.getBanner();
    this.getYxBanner();
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    jumpPage(url) {
      window.location.href = url;
    },
    toYxProject(id) {
      if (id) {
        this.$router.push({
          path: "/projectDetail",
          query: {
            itemId: id,
          },
        });
      } else {
        this.$router.push({
          path: "/yanxuanList",
        });
      }
    },
    getYxBanner() {
      this.$request.get("erpService/yw/api/customer/bannarList").then((res) => {
        if (res.success) {
          this.yXbanners = res.result;
        } else {
          this.$toast(res.message);
        }
      });
    },
    toUrl(path, query) {
      if (!path) {
        this.$dialog.alert({
          title: "提示",
          message: "该功能暂未开通",
        });
        return;
      }
      this.$router.push({
        path,
        query,
      });
    },

    toOneHouseOnePrice(itemId, xzqh) {
      this.$router.push({
        path: "/oneHouseOnePrice",
        query: { itemId, xzqh },
      });
    },

    toProject(itemId, old) {
      if (old == 1) {
        this.$router.push({
          path: "/projectDetailIndex",
          query: {
            itemId: itemId,
          },
        });
      } else {
        this.$router.push({
          path: "/projectDetail",
          query: {
            itemId: itemId,
          },
        });
      }
    },

    callTo(phone, lx, infoId) {
      if (!phone) {
        this.$dialog.alert({
          title: "提示",
          message: "暂无可拨打电话",
        });
        return;
      }
      this.$new
        .post(
          "telTj/addTeltj.do",
          qs.stringify({
            phone,
            lx,
            infoId,
          })
        )
        .then((res) => {
          window.location.href = `tel:${phone}`;
        });
    },
    callPhone(phone, lx, infoId) {
      if (!phone) {
        this.$dialog.alert({
          title: "提示",
          message: "暂无可拨打电话",
        });
        return;
      }
      this.$http.post("cms/onlineUser/reg/isLogin.do").then((res) => {
        if (res.success) {
          this.$new
            .post(
              "telTj/addTeltj.do",
              qs.stringify({
                phone,
                lx,
                infoId,
              })
            )
            .then((res) => {
              window.location.href = `tel:${phone}`;
            });
        } else {
          this.$toast(res.msg);
        }
      });
    },

    toAnnounce(saleItemId) {
      this.$router.push({
        path: "/announceDetail",
        query: {
          saleItemId,
        },
      });
    },
    toTop() {
      this.$refs.topBanner.scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "start", // 上边框与视窗顶部平齐。默认值
      });
    },

    //获取首页广告轮播

    getBanner() {
      this.$new
        .post(
          "ad/getAdList.do",
          qs.stringify({
            type: 6,
            xzqh: this.main.getHostArea(),
          })
        )
        .then((res) => {
          if (res.success) {
            this.banners = res.obj;
          }
        });
    },

    getTuiJian() {
      this.$new
        .post(
          "promoteHouse/getTypePage.do",
          qs.stringify({
            xzqh: this.main.getHostArea(),
            currPageNo: 1,
            pageSize: 6,
            type: 6,
          })
        )
        .then((res) => {
          if (res.obj) {
            this.$set(this, "list", res.obj);
          }
        });
    },
    onLoad() {
      if (this.tab === 1) {
        if (this.listPage == 1) {
          this.getTuiJian();
        }
        this.$new
          .post(
            "itemInfo/getByPage.do",
            qs.stringify({
              pageSize: 10,
              currPageNo: this.listPage,
              xzqh: this.main.getHostArea(),
              order: 0,
            })
          )
          .then((res) => {
            if (res.success) {
              this.list = this.list.concat(res.obj);
              this.loading = false;
              this.listPage += 1;
            } else {
              this.finished = true;
            }
          });
      } else if (this.tab === 2) {
        this.$http({
          url: "cms/houseListed/permit/getHouseList.do",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          data: {
            pageSize: 10,
            offset: (this.listPage - 1) * 10,
            area: this.main.getHostArea(),
          },
        }).then((res) => {
          if (res.success) {
            this.list = this.list.concat(res.obj.rows);
            this.loading = false;
            this.listPage += 1;
          } else {
            this.finished = true;
          }
        });
      } else if (this.tab === 0) {
        this.$new
          .post(
            "salePermit/getSalePermitListByPage.do",
            qs.stringify({
              pageSize: 10,
              currPageNo: this.listPage,
              xzqh: this.main.getHostArea(),
            })
          )
          .then((res) => {
            if (res.success) {
              this.list = this.list.concat(res.obj);
              this.loading = false;
              this.listPage += 1;
            } else {
              this.finished = true;
            }
          });
      }
    },
    // 获取广告
    getAd() {
      this.$new
        .post(
          "ad/getAdList.do",
          qs.stringify({
            xzqh: this.main.getHostArea(),
            type: 4,
          })
        )
        .then((res) => {
          if (res.obj) {
            this.ad = res.obj;
            this.offsetTop = document.querySelector(".tab_con").offsetTop;
          }
        });
    },
    // 获取新闻
    getNews() {
      this.$new
        .post(
          "news/getNewsByType.do",
          qs.stringify({
            pageSize: 3,
            currPageNo: this.newsPage,
            type: 8,
            xzqh: this.main.getHostArea(),
          })
        )
        .then((res) => {
          if (res.success) {
            this.$set(this, "newsMain", res.obj[0]);
            this.$set(this, "newsSm", res.obj.slice(1));
            if (res.attributes.pageCount > this.newsPage) {
              this.newsPage += 1;
            } else {
              this.newsPage = 1;
            }
          }
        });
    },
    // 推荐房源
    getRecommond() {
      this.$new
        .post(
          "promoteHouse/getTypePage.do",
          qs.stringify({
            currPageNo: 1,
            pageSize: 2,
            xzqh: this.main.getHostArea(),
            type: 8,
          })
        )
        .then((res) => {
          if (res.success) {
            this.recommondList = res.obj;
          }
        });
    },
    // 切换新房二手房列表
    changeTab(type) {
      this.tab = type;
      this.list = [];
      this.listPage = 1;
      this.loading = false;
      this.finished = false;
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      console.log("scroll");
      if (scrollTop > this.offsetTop) {
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "ProjetList" || to.name === "ProjectDetail") {
      // from.meta.y = document.documentElement.scrollTop
      this.$store.dispatch("saveView", ["Home"]).then(() => {
        next();
      });
    } else {
      this.$store.dispatch("saveView", []).then(() => {
        next();
      });
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="less" scoped>
.swiper {
  width: 7.04rem;
  margin: 0 auto;

  .van-swipe-item {
    height: 2.76rem;
    // padding: 0 0.08rem;
    box-sizing: border-box;
  }

  img {
    height: 2.76rem;
    width: 100%;
    border-radius: 0.08rem;
  }
}

.five_con {
  width: 7.04rem;
  margin: 0 auto;
  padding: 0.4rem 0rem;
  text-align: center;

  img {
    width: 1rem;
    height: 1rem;
    margin-bottom: 0.05rem;
  }

  font-size: 0.26rem;
  color: #202020;
  font-weight: 800;
}

.ten_con {
  width: 7.04rem;
  margin: 0 auto;
  padding: 0.2rem 0rem 0;

  .inner {
    width: 20%;
    text-align: center;
    font-size: 0.26rem;
    font-weight: 800;
    margin-bottom: 0.55rem;

    a {
      display: inline-block;
      height: 100%;
      width: 100%;
    }

    img {
      margin-bottom: 0.05rem;
      width: 0.46rem;
      height: 0.46rem;
    }
  }
}

/deep/ .van-swipe__indicator {
  height: 0.06rem;
  width: 0.3rem;
  border-radius: 0.03rem;
  opacity: 1;
}

.ad_con {
  height: 1.68rem;
  width: 7.04rem;
  margin: 0.2rem auto 0.34rem;

  img {
    width: 100%;
    height: 100%;
  }
}

.index_aside {
  width: 7.04rem;
  margin: 0 auto;

  > div {
    width: 3.44rem;
    height: 1.44rem;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    color: #ffffff;
    padding: 0 0.3rem;
    box-sizing: border-box;

    h4 {
      font-size: 0.3rem;
      font-weight: 800;
      // margin-bottom: 0.2rem;
    }

    p {
      font-size: 0.26rem;
      color: #ffffff;
    }

    &.left {
      background-image: url("../../assets/img/old/check.png");
    }

    &.right {
      background-image: url("../../assets/img/old/house.png");
    }

    &.new_left {
      background-image: url("../../assets/img/old/photo1.png");
    }

    &.new_right {
      background-image: url("../../assets/img/old/photo2.png");
    }
  }
}

.news_con {
  width: 7.04rem;
  margin: 0.68rem auto 0;

  .tit_con {
    h4 {
      font-size: 0.36rem;
      font-weight: 800;
    }

    p {
      font-size: 0.22rem;
      color: #3072f5;

      img {
        width: 0.24rem;
        height: 0.24rem;
        margin-top: 0.02rem;
        margin-right: 0.1rem;
      }
    }
  }

  .news_inner {
    margin-top: 0.34rem;

    .left {
      position: relative;
      width: 2.58rem;
      height: 2.58rem;

      img {
        height: 100%;
        width: 100%;
        position: absolute;
        display: block;
        top: 0;
      }

      p {
        z-index: 2;
        position: absolute;
        padding: 0.15rem 0.24rem;
        color: #fff;
        bottom: 0;
        left: 0;
        right: 0;
        background: -moz-linear-gradient(
          top,
          rgba(0, 0, 0, 0.1) 0%,
          rgba(0, 0, 0, 1) 100%
        );
        background: -webkit-gradient(
          linear,
          left top,
          left bottom,
          color-stop(0%, #000000),
          color-stop(100%, rgba(0, 0, 0, 1))
        );
        background: -webkit-linear-gradient(
          top,
          rgba(0, 0, 0, 0.1) 0%,
          rgba(0, 0, 0, 1) 100%
        );
        background: -o-linear-gradient(
          top,
          rgba(0, 0, 0, 0.1) 0%,
          rgba(0, 0, 0, 1) 100%
        );
        background: -ms-linear-gradient(
          top,
          rgba(0, 0, 0, 0.1) 0%,
          rgba(0, 0, 0, 1) 100%
        );
        background: linear-gradient(
          to bottom,
          rgba(0, 0, 0, 0.1) 0%,
          rgba(0, 0, 0, 1) 100%
        );
      }
    }

    .right {
      width: 4.32rem;

      .row {
        background-color: #f4f4f4;
        height: 1.24rem;

        &:not(:last-child) {
          margin-bottom: 0.1rem;
        }

        p {
          width: 3.08rem;
          padding: 0.24rem 0.22rem;
          box-sizing: border-box;
        }

        img {
          width: 1.24rem;
          height: 1.24rem;
        }
      }
    }
  }
}

.fixed {
  position: fixed;
  top: 1.1rem;
  left: 0;
  right: 0;
}

.pad_top {
  padding-top: 1.16rem;
}

.tab_con {
  height: 1.16rem;
  background-color: #fff;
  z-index: 9;

  span {
    font-weight: 800;
    font-size: 0.34rem;
    margin: 0.3rem;
    position: relative;
  }

  .active {
    color: #3072f5;
    font-size: 0.4rem;

    &:after {
      content: "";
      bottom: -0.2rem;
      position: absolute;
      display: block;
      left: 50%;
      margin-left: -0.2rem;
      background-color: #3072f5;
      width: 0.4rem;
      height: 0.04rem;
    }
  }
}

.recommond_con {
  width: 7.04rem;
  margin: 0.42rem auto 0;

  .inner {
    width: 3.42rem;
    height: 3rem;
    background-color: #f6f8fb;
    padding: 0.65rem 0.08rem 0rem;
    box-sizing: border-box;
    position: relative;

    i {
      background-color: #ff5432;
      color: #fff;
      width: 0.68rem;
      line-height: 0.32rem;
      border-radius: 0 0.12rem 0 0.12rem;
      display: block;
      text-align: center;
      font-size: 0.22rem;
      position: absolute;
      top: 0;
      left: 0;
    }

    h5 {
      font-size: 0.28rem;
      font-weight: 800;
      margin-bottom: 0.08rem;
    }

    p {
      color: #818181;
      font-size: 0.24rem;
    }

    .img_con {
      width: 100%;
      margin-top: 0.22rem;

      img {
        width: 1.6rem;
        height: 1.2rem;
      }
    }
  }
}

.list_con {
  margin: 0.05rem auto 0;
  width: 7.04rem;

  .inner_l {
    position: relative;

    i {
      width: 0.6rem;
      height: 0.34rem;
      text-align: center;
      line-height: 0.34rem;
      color: #fff;
      background-color: #24d064;
      font-size: 0.24rem;
      position: absolute;
      display: block;
      top: 0;
    }
  }

  .inner {
    padding: 0.35rem 0;
    border-bottom: 1px solid #f4f4f4;
  }

  .banner {
    width: 2.44rem;
    height: 1.84rem;
  }

  .new_r {
    width: 4.25rem;
    margin-left: 0.3rem;

    .tel {
      width: 0.36rem;
      height: 0.36rem;

      img {
        width: 100%;
      }
    }

    .col_gray {
      font-size: 0.24rem;
      color: #505050;
    }

    .tit {
      h4 {
        font-size: 0.36rem;
        color: #101010;
        font-weight: 800;
        width: 3rem;
        line-height: 0.52rem;
      }

      i {
        //width: 0.6rem;
        padding: 0 0.04rem;
        line-height: 0.34rem;
        color: #2f72f5;
        font-size: 0.24rem;
        text-align: center;
        border: 1px solid currentColor;
        box-sizing: border-box;
        border-radius: 0.02rem;
      }

      span {
        width: 0.6rem;
        height: 0.34rem;
        text-align: center;
        line-height: 0.34rem;
        color: #fff;
        background-color: #24d064;
        font-size: 0.24rem;
        border-radius: 0.02rem;
      }
    }
  }
}

.new_list {
  .inner {
    .new_r {
      img {
        width: 100%;
      }

      .col_gray {
        margin: 0.1rem 0;
      }

      .tit {
        h4 {
          width: 3rem;
        }

        i {
          width: auto;
          padding: 0 0.04rem;
        }
      }

      .info {
        color: #505050;
        font-size: 0.24rem;

        p {
          margin-right: 0.2rem;
        }

        span {
          color: #ff6a18;
        }
      }

      .col_red {
        margin-top: 0.1rem;

        h4 {
          font-size: 0.36rem;
          font-weight: 800;
        }

        span {
          font-size: 0.22rem;
        }
      }

      .text {
        margin-top: 0.1rem;
        font-size: 0.22rem;
        color: #a0a0a0;

        i {
          font-size: 0.18rem;
        }
      }
    }
  }
}

.old_list {
  .inner {
    .inner_l {
      position: relative;

      i {
        width: 0.6rem;
        height: 0.34rem;
        text-align: center;
        line-height: 0.34rem;
        color: #fff;
        background-color: #24d064;
        font-size: 0.24rem;
        position: absolute;
        display: block;
        top: 0;
      }
    }

    .new_r {
      .col_gray {
        margin: 0.04rem 0;
      }

      .price {
        h4 {
          font-size: 0.34rem;
          color: #ff4532;
        }

        p {
          font-size: 0.24rem;
          color: #aaaaaa;
          margin-left: 0.12rem;
        }
      }

      .num {
        margin-top: 0.04rem;
        color: #3072f5;

        img {
          width: 0.3rem;
          height: 0.3rem;
        }

        span {
          margin: 0 0.1rem;
          color: #383333;
        }
      }
    }
  }
}

.pre_list {
  .col_gray {
    &:not(:last-child) {
      margin: 0.22rem 0;
    }
  }
}

.to_top {
  width: 0.84rem;
  height: 0.84rem;
  position: fixed;
  z-index: 8;
  right: 0.15rem;
  bottom: 2rem;
}
</style>
